import {request} from '@/utils/http';

let batch= '/fronted/goods/report_file/query';
let batchupload = '/fronted/goods/report_file/download/'

export function GET_BATCH(params){
  return request(batch,'get',params)
}
export function GET_BATCHUPLOAD(params){
  let headers={'Content-Type': 'application/x-www-form-urlencoded'}
    return request(batchupload+params.id,'get',params,headers,false)
  }


// WEBPACK FOOTER //
// ./src/api/check.api.js